import NartResponse from "../../../../../api/models/product/NartResponse";
import BaseProductResponse from "../../../../../api/models/product/BaseProductResponse";
import ProductNameResponse from "../../../../../api/models/product/ProductNameResponse";
import ProductReferenceResponse from "../../../../../api/models/ProductReferenceResponse";
import { ProductSuggestionFormType } from "../ProductSuggestion.form-model";

export const MIN_NART_CHARACTERS = 2;

export interface ProductSuggestionInnerFormikProps {
  nartField: NartResponse;
  productNameField: ProductNameResponse;
  baseProductField: BaseProductResponse;
}

export const initialFormValues: ProductSuggestionInnerFormikProps = {
  nartField: { nart: "" },
  productNameField: { code: "", description: "" },
  baseProductField: { code: "", description: "" },
};

export interface ProductSuggestionFormProps {
  readOnly?: boolean;
  preset?: ProductReferenceResponse | null;
  handleSubmit: (values: ProductSuggestionFormType) => void;
}
